export const PRICING = {
    'Newspaper': 15, 'Books': 10, 'Cartons': 8, 
    'HDPE Bottles': 20, 'PET Bottles': 25, 'Mixed Plastic': 12,
    'Iron Scrap': 30, 'Aluminum Scrap': 50, 'Copper Scrap': 120
};

export const SCRAP_CATEGORIES = [
    { id: 1, name: 'Paper/Cardboard', icon: '📄', products: ['Newspaper', 'Books', 'Cartons'] },
    { id: 2, name: 'Plastics', icon: '🥤', products: ['HDPE Bottles', 'PET Bottles', 'Mixed Plastic'] },
    { id: 3, name: 'Metals', icon: '🔩', products: ['Iron Scrap', 'Aluminum Scrap', 'Copper Scrap'] },
    { id: 4, name: 'E-Waste', icon: '💻', products: ['Old Electronics', 'Batteries', 'Wires'] },
];

export const CUSTOMER_REVIEWS = [
    { name: 'Priya S.', rating: 5, review: 'Super fast pickup and fair prices! Great way to recycle responsibly.' },
    { name: 'Amit K.', rating: 4, review: 'The app is easy to use. The executive was polite and on time.' },
    { name: 'Zoya M.', rating: 5, review: 'Love the eco-friendly focus. Highly recommend for managing waste.' },
];

export const INITIAL_ADDRESSES = [
    { id: 'addr1', label: 'Home', address: 'Dadar West', city: 'Terra', default: true, latitude: 34.0522, longitude: -118.2437 },
    { id: 'addr2', label: 'Office', address: '456, Eco Tower, Recycle Lane', city: 'Terra', default: false, latitude: 34.0522, longitude: -118.2437 },
];